import { useSyncExternalStore } from 'react';

// QUANTI OGGETTI PORTANO UN MATERIALE CAMBIA FUORI DALL'ELENCO DEI MATERIALI (QA, 2026-10-19): lo slot
// dell'Inspector di un oggetto, la sostituzione sotto un Empty, «Apply to selection». Nessuno di questi
// tocca i nodi dell'elenco, e l'elenco rifaceva i conti solo quando cambiavano i nodi — cioè creando un
// materiale nuovo. Il motore non avvisa quando una mesh cambia materiale: lo dice chi la cambia, qui.
let revision = 0;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

/** Un materiale è stato messo su una mesh o tolto: chi conta le mesh di un materiale rifà i conti. */
export const notifyMaterialUsageChanged = () => {
    revision++;
    listeners.forEach((listener) => listener());
};

/** Cambia a ogni `notifyMaterialUsageChanged`: va fra le dipendenze di chi fa i conti. */
export const useMaterialUsageRevision = () => useSyncExternalStore(subscribe, () => revision);
